import classnames from "classnames";
import ExpanderOld from "components/components/ExpanderOld/ExpanderOld";
import useToggle from "hooks/useToggle";
import React from "react";
import featureFlags from "utils/featureFlags";

import {
  StyledButton,
  StyledCard,
  StyledDiv,
  StyledHeader,
  Subtitle,
  Title,
} from "./style";

interface Props {
  title: string;
  subtitle?: string;
  content: JSX.Element;
  classModifier?: string;
  expanderIconType?: ExpanderIconType;
  isFirst?: boolean;
}

// symbols refer to icons as font, specified in /src/assets/fonts/elexon-uat.ttf
const ExpanderIcon = {
  PlusMinus: { firstExpanderIcon: "*", secondExpanderIcon: "(" },
  Arrow: { firstExpanderIcon: "3", secondExpanderIcon: "o" },
} as const;

export enum ExpanderIconType {
  PlusMinus = "PlusMinus",
  Arrow = "Arrow",
}

const Expander: React.FC<Props> = ({
  title,
  subtitle,
  content,
  classModifier,
  expanderIconType = ExpanderIconType.PlusMinus,
  isFirst = false,
}: Props) => {
  const [expanded, toggleExpanded] = useToggle(false);
  const { firstExpanderIcon, secondExpanderIcon } =
    ExpanderIcon[expanderIconType];
  return (
    <StyledCard
      className={classnames(classModifier, { expanded, first: isFirst })}
    >
      <StyledHeader onClick={toggleExpanded} data-test-id="expander-header">
        <StyledButton
          type="button"
          data-test-id="expander-button"
          aria-label={expanded ? "less information" : "more information"}
        >
          {expanded ? firstExpanderIcon : secondExpanderIcon}
        </StyledButton>
        <Title data-test-id="expander-title-content">{title}</Title>
        {subtitle && <Subtitle>{subtitle}</Subtitle>}
      </StyledHeader>
      <StyledDiv className={classnames({ expanded })}>
        <div data-test-id="expander-content">{content}</div>
      </StyledDiv>
    </StyledCard>
  );
};

export default featureFlags.rebrand ? Expander : ExpanderOld;
